// extracted by mini-css-extract-plugin
export default {"notFound":"NotFound_notFound__rJuV1","redirUrl":"NotFound_redirUrl__Iaw2K"};